module.exports = __webpack_public_path__ + "img/header-engagementRingsRedgold@2x.7c5dd96.webp";